import React, { PureComponent } from "react";
import styled from "styled-components";
import { cssMainSelector } from "../lib/cssSelectors";
import MaterialIcon from "./MaterialIcon";
import { withTranslation } from "react-i18next";
import NonDefaultFiltersLineContainer from "../containers/NonDefaultFiltersLineContainer";
import { CSS_CLASS_PREFIX } from "../constants/css";

const Container = styled.div``;

const Header = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    font-size: ${p => p.theme.noResults.headerSize};
    font-weight: ${p => p.theme.font.weightSemiBold};

    .${CSS_CLASS_PREFIX}-material-icon {
      color: ${p => p.theme.color.darkGray};
      font-size: ${p => p.theme.noResults.headerSize};
    }
  }
`;

const Text = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    padding-top: ${p => p.theme.spacing.md};
  }
`;

const FilterWrapper = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    padding-top: ${p => p.theme.spacing.md};
  }
`;

class NoResults extends PureComponent {
  render() {
    const { t } = this.props;

    return (
      <Container>
        <Header>
          <MaterialIcon>warning</MaterialIcon> {t("header")}
        </Header>
        <Text>{t("text")}</Text>
        <FilterWrapper>
          <NonDefaultFiltersLineContainer />
        </FilterWrapper>
      </Container>
    );
  }
}

export default withTranslation(["noResults"])(NoResults);
